import { useEffect, useState } from 'react';
import useApiUrl from './useApiUrlHook';
import axios from 'axios';

export default function useExtraFields() {
    const [extraFields, setExtraFields] = useState(null);
    const apiUrl = useApiUrl();

    useEffect(() => {
        async function get() {
            if (apiUrl == null) return;

            await axios
                .get(`${apiUrl}/extra_fields`)
                .then((response) => {
                    setExtraFields(response.data);
                })
                .catch((error) => {
                    throw new Error(error);
                });
        }
        if (extraFields === null) {
            get();
        }
    }, [extraFields, apiUrl]);

    return extraFields;
}
